// extracted by mini-css-extract-plugin
export default {"root":"LayoutSingleColumn_root__1blLa","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__zOvja"};